/* eslint-disable no-console */

export function isInIframe() {
  return window.self !== window.top
}

function getOrigin() {
  const { origin } = window.location
  if (origin.includes('localhost')) {
    return '*'
  }

  try {
    const referrerUrl = new URL(document.referrer)
    return referrerUrl.origin
  } catch {
    console.warn('Could not parse referrer URL, falling back to "*"')
    return '*'
  }
}

export function sendTypedMessage(type, msg) {
  if (isInIframe()) {
    window.parent.postMessage(
      {
        type,
        data: msg
      },
      getOrigin()
    )
  }
}

export function sendMessage(msg) {
  if (isInIframe()) {
    window.parent.postMessage(msg, getOrigin())
  }
}

export function onLinkClick(type, data) {
  return () => {
    window.parent.postMessage({ type, data }, getOrigin())
  }
}
